import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue";
var _hoisted_1 = {
  class: "header_box"
};
var _hoisted_2 = {
  key: 0,
  class: "title"
};
export default {
  __name: 'headerWork',
  props: {
    title: {
      default: '',
      type: String
    },
    is_showBack: {
      default: false,
      type: Boolean
    }
  },
  emits: ['onBack'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var handleBack = () => {
      emit('onBack');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.title ? (_openBlock(), _createElementBlock("span", _hoisted_2, [__props.is_showBack ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "iconfont icon-31fanhui1",
        onClick: handleBack
      })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.title), 1)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")]);
    };
  }
};